import React from "react";
import styled from "styled-components";

import { Icon, Typography } from "@virkesborsen/ui-component-library";

const ChipItem = styled.div`
  width: fit-content;
  display: flex;
  padding: 4px 8px;
  border-radius: 16px;
`;

const Chip = ({ type, label }) => {
  const styles = {
    unseen: {
      textColor: "info-700",
      bgColor: "semantic-info-200",
      icon: "MailSimple",
      text: "Nytt",
    },
    seen: {
      textColor: "pebble-900",
      bgColor: "pebble-200",
      icon: "CheckSimple",
      text: "Läst",
    },
    ongoing: {
      textColor: "warning-700",
      bgColor: "warning-200",
      icon: "HourglassSimple",
      text: "Pågående",
    },
    beta: {
      textColor: "info-800",
      bgColor: "info-200",
      text: "Beta",
    },
    black: {
      textColor: "white",
      bgColor: "charcoal-500",
      text: label,
    },
    plus: {
      textColor: "black",
      bgColor: "primary-core",
      text: "Plus"
    }
  };

  if (type === "done") {
    return null;
  }

  const i = styles[type];
  if (i) {
    return (
      <ChipItem className={`bg-${i.bgColor} ${i.textColor}`}>
        {i.icon && <Icon name={i.icon} size="large" color={i.textColor} />}
        <Typography variant="labelMediumMedium">{i.text}</Typography>
      </ChipItem>
    );
  } else {
    return null;
  }
};

export { Chip };
